/* SV v9 modernisation — scroll-reveal + light interactions
   Loaded once globally via theme.liquid. Defer-loaded.
   Respects prefers-reduced-motion.
*/
(function () {
  'use strict';

  if (window.svModernInit) return;
  window.svModernInit = true;

  var prefersReduced = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    // ---- M8 · Scroll-reveal -------------------------------------
    if (!prefersReduced && 'IntersectionObserver' in window) {
      // Auto-tag common section blocks for fade-up
      var autoTargets = document.querySelectorAll(
        '.index-section .section-header, ' +
        '.index-section .feature-row, ' +
        '.index-section .grid-product, ' +
        '.index-section .image-with-text, ' +
        '.index-section .collection-list__item, ' +
        '.index-section blockquote, ' +
        '.index-section .feature-row__text, ' +
        '.index-section .quote-section'
      );
      autoTargets.forEach(function (el) {
        if (!el.hasAttribute('data-sv-reveal')) el.setAttribute('data-sv-reveal', '');
      });

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('sv-revealed');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

      document.querySelectorAll('[data-sv-reveal]').forEach(function (el) {
        io.observe(el);
      });
    } else {
      // Reduced motion or no IO support → reveal immediately
      document.querySelectorAll('[data-sv-reveal]').forEach(function (el) {
        el.classList.add('sv-revealed');
      });
    }
  }

  // ---- M11 · Footer oversized brand line: removed entirely ----
  // (One-time DOM cleanup runs on load to remove any leftover brand divs.)
  (function () {
    function svRemoveFooterBrand() {
      var existing = document.querySelectorAll('.sv-footer-brand');
      for (var i = 0; i < existing.length; i++) {
        if (existing[i].parentNode) existing[i].parentNode.removeChild(existing[i]);
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', svRemoveFooterBrand);
    } else {
      svRemoveFooterBrand();
    }
  })();

  // ---- M10 · Mobile cart count live update --------------------
  function syncCartCount() {
    var badge = document.querySelector('[data-sv-cart-count]');
    if (!badge) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = cart && cart.item_count ? cart.item_count : 0;
        if (n > 0) {
          badge.textContent = n;
          badge.removeAttribute('hidden');
        } else {
          badge.setAttribute('hidden', '');
        }
      })
      .catch(function () {});
  }

  // ---- PDP · Combined availability block ----------------------
  // Merge stock line + Shopify pickup-availability into one tidy card.
  //
  //   ● 2 left · Dispatches in 1–2 business days
  //   ● Pickup at Gold Coast Warehouse · Usually ready in 4 hours
  //
  function dispatchSuffix(node) {
    var section = node && node.closest('[data-section-type="product"]');
    var text = section && section.getAttribute('data-sv-dispatch-text');
    return text ? ' \u00b7 ' + text : '';
  }

  function deriveStockText(rawNode) {
    var raw = (rawNode.textContent || '').trim();
    if (!raw) return null;
    var lowMatch = raw.match(/(?:low stock\s*[-\u2013\u2014]\s*)?(?:only\s+)?(\d+)\s+items?\s+left/i);
    if (lowMatch) return { text: lowMatch[1] + ' left' + dispatchSuffix(rawNode), tone: 'low' };
    if (/in stock/i.test(raw) && /ready to ship|ship/i.test(raw))
      return { text: 'In stock' + dispatchSuffix(rawNode), tone: 'ok' };
    if (/^\s*in stock\s*$/i.test(raw))
      return { text: 'In stock' + dispatchSuffix(rawNode), tone: 'ok' };
    if (/sold out|unavailable|out of stock/i.test(raw))
      return { text: raw, tone: 'out' };
    if (/backorder|shipping soon/i.test(raw))
      return { text: raw, tone: 'low' };
    return { text: raw, tone: 'ok' };
  }

  // State flag to prevent observer feedback loops
  var svDomBusy = false;

  // Escape + selectively bold the location name for the pickup sentence.
  function escHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function linkifySentence(sentence) {
    // Match "<prefix> at <Location>[ · <stockText>]" and bold the location only
    var m = sentence.match(/^(.*?\bat\s+)([^\u00b7]+?)(\s*\u00b7\s*.+)?$/i);
    if (m) {
      return escHtml(m[1]) + '<strong>' + escHtml(m[2].trim()) + '</strong>' + (m[3] ? escHtml(m[3]) : '');
    }
    return escHtml(sentence);
  }

  function pickFreshestHolder() {
    // Prefer a non-hidden holder with actual content. Fall back to any holder.
    var all = document.querySelectorAll('[data-store-availability-holder], .store-availability-container, .store-availabilities-container');
    for (var i = 0; i < all.length; i++) {
      var h = all[i];
      if (h.dataset.svHidden) continue;
      var hasText = (h.textContent || '').trim().length > 0;
      if (hasText) return h;
    }
    return all[0] || null;
  }

  function shouldHideAvailabilityCard() {
    var productSection = document.querySelector('[data-section-type="product"]');
    if (!productSection) return false;
    if (productSection.hasAttribute('data-sv-hide-availability')) return true;

    var template = (productSection.getAttribute('data-product-template') || '').toLowerCase();
    var handle = (productSection.getAttribute('data-product-handle') || '').toLowerCase();
    var title = (productSection.getAttribute('data-product-title') || '').toLowerCase();
    var type = (productSection.getAttribute('data-product-type') || '').toLowerCase();

    return template.indexOf('rental') !== -1 ||
      template.indexOf('surf-hire') !== -1 ||
      handle.indexOf('hire') !== -1 ||
      title.indexOf('hire') !== -1 ||
      type.indexOf('hire') !== -1 ||
      type.indexOf('rental') !== -1;
  }

  function buildAvailabilityCard() {
    if (svDomBusy) return;
    if (shouldHideAvailabilityCard()) {
      var existingCard = document.querySelector('.sv-availability');
      if (existingCard) existingCard.remove();
      return;
    }

    var salesBlock = document.querySelector('.product-block--sales-point');
    var pickupHolder = pickFreshestHolder();
    if (!salesBlock && !pickupHolder) return;

    svDomBusy = true;
    try {
      // Find or create the unified container
      var card = document.querySelector('.sv-availability');
      if (!card) {
        card = document.createElement('div');
        card.className = 'sv-availability product-block';
        var anchor = salesBlock || pickupHolder.closest('.product-block') || pickupHolder.parentNode;
        anchor.parentNode.insertBefore(card, anchor);
      }

      // Move card to sit AFTER the Add-to-cart / Back Soon button block — ONCE only
      if (!card.dataset.svAnchored) {
        var cartBtn = document.querySelector('.payment-buttons');
        var addBlock = cartBtn ? cartBtn.closest('.product-block') : null;
        if (addBlock && addBlock.parentNode && addBlock.nextSibling !== card) {
          addBlock.parentNode.insertBefore(card, addBlock.nextSibling);
          card.dataset.svAnchored = '1';
        }
      }

      // ── Stock row ──────────────────────────────────────────
      // Truth source for availability = the Add-to-cart button's disabled state.
      // If the button is disabled / says sold-out, the variant is unavailable
      // regardless of what the Impulse sales-point text says.
      var atcBtn = document.querySelector('button[data-add-to-cart]');
      var atcText = atcBtn ? (atcBtn.textContent || '').trim() : '';
      var btnDisabled = atcBtn ? (atcBtn.disabled || atcBtn.hasAttribute('disabled') ||
                                 atcBtn.classList.contains('disabled') ||
                                 /sold out|unavailable|back soon|restock|currently unavailable/i.test(atcText))
                              : false;

      var isPreorder = /pre[\s-]?order/i.test(atcText);
      var productSection = atcBtn ? atcBtn.closest('[data-section-type="product"]') : null;
      var productForm = atcBtn ? atcBtn.form || atcBtn.closest('form') : null;
      var variantInput = productForm ? productForm.querySelector('[name="id"]') : null;
      var variantId = variantInput ? String(variantInput.value || '') : '';
      var inventoryData = productSection && /^\d+$/.test(variantId) ?
        productSection.querySelector('.js-variant-inventory-data[data-id="' + variantId + '"]') : null;
      var quantityText = inventoryData ? inventoryData.getAttribute('data-quantity') : null;
      var inventoryQuantity = quantityText !== null && quantityText !== '' && isFinite(Number(quantityText)) ? Number(quantityText) : null;
      var stockConfirmed = inventoryQuantity !== null && inventoryQuantity > 0;
      var availabilityUnconfirmed = false;
      var info = null;
      if (isPreorder && !btnDisabled) {
        info = { text: 'Preorder \u00b7 Ships on the preorder date shown above', tone: 'low' };
      } else if (btnDisabled) {
        info = { text: 'Sold out', tone: 'out' };
      } else if (salesBlock && (inventoryQuantity === null || stockConfirmed)) {
        var visibleSalesText = salesBlock.querySelector('.sales-point:not(.hide) [data-product-inventory], .sales-point:not(.hide) .icon-and-text');
        if (visibleSalesText) info = deriveStockText(visibleSalesText);
      }
      if (!info && atcBtn && !btnDisabled) {
        availabilityUnconfirmed = !stockConfirmed;
        info = stockConfirmed ?
          { text: 'In stock' + dispatchSuffix(productSection), tone: 'ok' } :
          { text: 'Check availability before ordering', tone: 'low' };
      }

      if (info) {
        var stockRow = card.querySelector('.sv-availability__stock');
        var desired = info.tone + '|' + info.text;
        if (!stockRow || stockRow.dataset.svText !== desired) {
          if (!stockRow) {
            stockRow = document.createElement('div');
            stockRow.className = 'sv-availability__row sv-availability__stock';
            card.insertBefore(stockRow, card.firstChild);
          }
          stockRow.setAttribute('data-tone', info.tone);
          stockRow.dataset.svText = desired;
          stockRow.innerHTML =
            '<span class="sv-availability__dot" aria-hidden="true"></span>' +
            '<span class="sv-availability__text"></span>';
          stockRow.querySelector('.sv-availability__text').textContent = info.text;
        }

        var deliveryRow = card.querySelector('.sv-availability__delivery');
        if (!deliveryRow) {
          deliveryRow = document.createElement('div');
          deliveryRow.className = 'sv-availability__row sv-availability__delivery';
          deliveryRow.innerHTML =
            '<svg class="sv-availability__delivery-icon" viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
              '<path d="M16.5 43.22H6.88V16.5h33.14v26.72H23.94"/>' +
              '<path d="M45.42 43.22h-5.4V30.4h17.1v12.82h-4.23"/>' +
              '<path d="m57.12 30.4-6.41-8.56H40.02"/>' +
              '<circle cx="20.24" cy="43.76" r="3.74"/>' +
              '<circle cx="49.16" cy="43.76" r="3.74"/>' +
            '</svg>' +
            '<span class="sv-availability__text">Delivery · We ship via fast couriers and send tracking. Shipping or local pickup options shown at checkout.</span>';
          stockRow.insertAdjacentElement('afterend', deliveryRow);
        }
      }

      // ── Pickup row ───────────────────────────────────────────────
      // Recompose Shopify's three-line pickup block into one tight sentence:
      //   Pickup available at <Location> · Usually ready in 4 hours
      //   <link: View pickup information>
      // If no fresh pickup data exists for this variant, remove any stale pickup row
      var havePickup = pickupHolder && (pickupHolder.textContent || '').trim().length > 0;
      if (!havePickup) {
        var staleRow = card.querySelector('.sv-availability__pickup');
        if (staleRow) staleRow.remove();
      }

      if (havePickup) {
        // Extract location name + the original link from Shopify's block
        var srcHolder = pickupHolder;
        var titleNode = srcHolder.querySelector(
          '.store-availability-information__title, .store-availability__title, ' +
          '.store-availabilities-information__title, .store-availabilities-list__title, strong, h2, h3'
        );
        var linkNode  = srcHolder.querySelector(
          '.store-availability-information__link, .store-availability__link, ' +
          '.store-availabilities-list__link, a'
        );

        var titleText = titleNode ? (titleNode.textContent || '').trim() : '';
        if (!titleText) {
          var raw = (srcHolder.textContent || '').replace(/\s+/g, ' ').trim();
          raw = raw.replace(/\s*(view store information|view store|check availability at other stores|check other stores|usually ready.*)$/i, '').trim();
          titleText = raw;
        }

        // Pickup follows variant buyability: if the ATC button is disabled,
        // the selected variant isn't available for pickup either (overrides any
        // stale pickup holder left in the DOM from a previous variant).
        var isUnavail = btnDisabled || /unavailable|not available/i.test(titleText);
        // Extract just the location name ("Gold Coast Warehouse - GC3PL Currumbin Waters")
        var locMatch = titleText.match(/\bat\s+(.+)$/i);
        var location = locMatch ? locMatch[1].trim() : titleText;

        var label = (isPreorder ? 'Pickup after preorder stock arrives \u2014 ' : (isUnavail ? 'Pick up unavailable \u2014 ' : (availabilityUnconfirmed ? 'Check pickup availability \u2014 ' : 'Pick up available \u2014 '))) + location;

        var pickupRow = card.querySelector('.sv-availability__pickup');
        if (!pickupRow) {
          pickupRow = document.createElement('div');
          pickupRow.className = 'sv-availability__row sv-availability__pickup';
          card.appendChild(pickupRow);
        }

        if (pickupRow.dataset.svPickup !== label) {
          pickupRow.dataset.svPickup = label;
          pickupRow.innerHTML = '<a class="sv-availability__pickup-link sv-availability__text" href="#"></a>';
          var link = pickupRow.querySelector('.sv-availability__pickup-link');
          link.textContent = label;
          // Hook click to the original Shopify link so the modal opens
          link.addEventListener('click', function (ev) {
            ev.preventDefault();
            var orig = srcHolder.querySelector('.store-availability-information__link, .store-availability__link, a');
            if (orig) orig.click();
          });
        }

        // Keep the Shopify block mounted but hidden so its modal keeps working
        if (srcHolder && srcHolder.parentNode && !srcHolder.dataset.svHidden) {
          srcHolder.style.display = 'none';
          srcHolder.dataset.svHidden = '1';
        }

        pickupRow.setAttribute('data-tone', isUnavail ? 'out' : (availabilityUnconfirmed || isPreorder ? 'low' : 'ok'));
      }

      // Hide the now-redundant original sales-point block — once
      if (salesBlock && salesBlock.style.display !== 'none' && card.querySelector('.sv-availability__stock')) {
        salesBlock.style.display = 'none';
      }
    } finally {
      // Release the flag on the next microtask so our own mutations don't re-trigger us
      setTimeout(function () { svDomBusy = false; }, 0);
    }
  }

  // Back-compat alias used by previous rewriter
  function rewriteSalesPoint() { buildAvailabilityCard(); }

  // ---- PDP · Reword the sold-out / "Back soon.." button --------
  //   "Back soon.."  →  "Currently unavailable"
  //   "Sold out"     →  "Currently unavailable"
  //   (23 Sep 2026: "— restocking soon" dropped from all sold-out wording.)
  function rewriteSoldOutLabel() {
    var SOLDOUT_LABEL = 'Sold out';
    var targets = document.querySelectorAll('[data-add-to-cart-text], .add-to-cart span, .btn--add-to-cart span');
    targets.forEach(function (el) {
      var raw = (el.textContent || '').trim();
      if (!raw) return;
      if (/^back soon\.*$/i.test(raw) || /^sold out$/i.test(raw) || /^unavailable$/i.test(raw)) {
        if (el.textContent.trim() !== SOLDOUT_LABEL) {
          // Preserve any icon children; only rewrite the text node
          var replaced = false;
          Array.from(el.childNodes).forEach(function (n) {
            if (n.nodeType === 3) {
              if (!replaced) { n.nodeValue = SOLDOUT_LABEL; replaced = true; }
              else { n.nodeValue = ''; }
            }
          });
          if (!replaced) el.textContent = SOLDOUT_LABEL;
        }
      }
    });
    // Also rewrite variant-dropdown option labels suffixed with "- Back soon.."
    document.querySelectorAll('select[data-product-select] option, select[name="id"] option').forEach(function (opt) {
      if (opt.dataset.svRewritten) return;
      var t = opt.textContent || '';
      if (/-\s*back soon\.*$/i.test(t)) {
        opt.textContent = t.replace(/-\s*back soon\.*$/i, '- Sold out');
        opt.dataset.svRewritten = '1';
      }
    });
  }

  // ---- Trust strip injector (M14) -----------------------------------------
  function injectTrustStrip() {
    // The trust badge on this Impulse theme is a single combined PNG (3 badges baked in).
    // It lives inside <div class="product-block"> > .image-wrap > image-element > img.
    // We identify it by the filename and replace the parent product-block content with our SVG strip.
    var badgeImgs = document.querySelectorAll(
      '.product-block .image-wrap img[src*="Gold_Black_Modern_Handmade_Badge"],' +
      ' .product-block .image-wrap img[src*="Aussie"],' +
      ' .product-block .image-wrap img[src*="Safe_Secure"],' +
      ' .product-block .image-wrap img[src*="Quality_Value"]'
    );
    var hosts = [];
    badgeImgs.forEach(function(img){
      var pb = img.closest('.product-block');
      if (pb && hosts.indexOf(pb) === -1) hosts.push(pb);
    });
    if (!hosts.length) return;
    hosts.forEach(function (host) {
      if (host.dataset.svTrustStripDone === '1') return;
      host.dataset.svTrustStripDone = '1';
      host.classList.add('sv-trust-host');
      var strip = document.createElement('div');
      strip.className = 'sv-trust-strip';
      strip.setAttribute('aria-label', 'Trust signals');
      strip.innerHTML = ''
        // Cell 1 — Aussie Owned & Independent (Australia map outline)
        + '<div class="sv-trust-strip__cell">'
        +   '<svg class="sv-trust-strip__icon" viewBox="0 0 64 56" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
        +     '<path d="M14 18 C 11 14, 13 9, 17 8 C 22 7, 26 11, 31 11 C 36 11, 40 9, 45 10 C 50 11, 54 14, 56 18 C 58 22, 57 27, 55 31 C 54 33, 56 35, 57 38 C 58 41, 56 44, 53 45 C 50 46, 47 44, 45 42 C 43 40, 40 41, 38 43 C 36 45, 33 47, 30 46 C 27 45, 25 42, 23 40 C 21 38, 18 39, 16 40 C 13 41, 10 39, 9 36 C 8 33, 10 30, 12 27 C 13 24, 12 21, 14 18 Z"/>'
        +     '<circle cx="54" cy="49" r="1.6" fill="currentColor" stroke="none"/>'
        +   '</svg>'
        +   '<div class="sv-trust-strip__label">Aussie Owned &amp; Independent</div>'
        +   '<div class="sv-trust-strip__sub">proudly local, surfer-run</div>'
        + '</div>'
        // Cell 2 — Secure Checkout (padlock, kept)
        + '<div class="sv-trust-strip__cell">'
        +   '<svg class="sv-trust-strip__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
        +     '<rect x="4" y="10" width="16" height="11" rx="2"/>'
        +     '<path d="M8 10V7a4 4 0 0 1 8 0v3"/>'
        +     '<circle cx="12" cy="15.5" r="1.2" fill="currentColor"/>'
        +   '</svg>'
        +   '<div class="sv-trust-strip__label">Secure Checkout</div>'
        +   '<div class="sv-trust-strip__sub">trusted payment methods</div>'
        + '</div>'
        // Cell 3 — Designed for Purpose (star, kept)
        + '<div class="sv-trust-strip__cell">'
        +   '<svg class="sv-trust-strip__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
        +     '<path d="M12 2l2.6 5.6L21 8.4l-4.5 4.4 1.1 6.4L12 16.9 6.4 19.2l1.1-6.4L3 8.4l6.4-.8L12 2z"/>'
        +   '</svg>'
        +   '<div class="sv-trust-strip__label">Designed for Purpose</div>'
        +   '<div class="sv-trust-strip__sub">created on the Gold Coast</div>'
        + '</div>';
      host.appendChild(strip);
    });
  }

  // ---- Value pack accent (M15) -------------------------------------------
  // Wraps the words "value pack" inside any heading so we can colour them orange via CSS.
  // Targets bundly heading + product-card titles + collection grid titles.
  function accentValuePack() {
    var rx = /value\s+pack/gi;
    var selectors = [
      // Bundly section heading (cross-sell to value pack from a regular PDP)
      'h2.bundly__heading', 'h1.bundly__heading', 'h3.bundly__heading',
      // Bundly card title (the grouped pack card itself)
      '.bundly__bundle_title', '.bundly__bundle h1', '.bundly__bundle h2', '.bundly__bundle h3',
      // Bundly product title on the value-pack PDP
      '.bundly__title h1', '.bundly__title h2', '.bundly__title',
      // Generic product titles (cards on collection / search / quick-add)
      '.grid-product__title', '.product-card__title', '.product-item__title',
      'a.grid-view-item__link .grid-view-item__title',
      // PDP main title
      '.product-single__title',
      // Selleasy item names (in case any are value packs)
      '.lb-flat-card .lb-product-name', '.lb-flat-card [class*="product-name"]'
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.dataset.svVpAccented === '1') return;
        // Walk only direct text nodes (don’t damage nested anchors/spans)
        var nodes = [];
        (function collect(node) {
          if (node.nodeType === 3) { nodes.push(node); return; }
          if (node.nodeType !== 1) return;
          // Skip our own accents and existing scripts/styles
          if (node.classList && node.classList.contains('sv-vp-accent')) return;
          Array.from(node.childNodes).forEach(collect);
        })(el);
        var changed = false;
        nodes.forEach(function (tn) {
          if (!rx.test(tn.nodeValue)) { rx.lastIndex = 0; return; }
          rx.lastIndex = 0;
          var frag = document.createDocumentFragment();
          var src = tn.nodeValue;
          var lastIdx = 0;
          var m;
          while ((m = rx.exec(src)) !== null) {
            if (m.index > lastIdx) frag.appendChild(document.createTextNode(src.slice(lastIdx, m.index)));
            var span = document.createElement('span');
            span.className = 'sv-vp-accent';
            span.textContent = m[0];
            frag.appendChild(span);
            lastIdx = m.index + m[0].length;
          }
          if (lastIdx < src.length) frag.appendChild(document.createTextNode(src.slice(lastIdx)));
          tn.parentNode.replaceChild(frag, tn);
          changed = true;
        });
        if (changed) el.dataset.svVpAccented = '1';
      });
    });
  }

  // ---- M16 · PDP description copy rewrites -------------------------------
  // Token has theme-asset write only, not product write — so we replace dated
  // copy on the rendered DOM. Currently: "in our store" → "with us" (user has
  // no retail store). Runs once on PDP load.
  function rewritePdpCopy() {
    var roots = document.querySelectorAll(
      '.product-single__description, .rte, [class*="product-block"] .rte, ' +
      '.product-single__meta .rte, .grid__item .rte'
    );
    if (!roots.length) return;
    var rxStore = /\bin our store\b/gi;
    roots.forEach(function (root) {
      if (root.dataset.svCopyDone === '1') return;
      var changed = false;
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = walker.nextNode())) {
        if (rxStore.test(n.nodeValue)) {
          n.nodeValue = n.nodeValue.replace(rxStore, 'with us');
          changed = true;
        }
      }
      if (changed) root.dataset.svCopyDone = '1';
    });
  }

  // ---- M17 · Bundly button rewrite ---------------------------------------
  // Strips the dated "👉 View bundle 👈" emoji wrapper. CSS handles the pill
  // restyle, JS just owns the text content.
  function rewriteBundlyButton() {
    document.querySelectorAll('a.bundly__view_bundle_button').forEach(function (a) {
      if (a.dataset.svBundleDone === '1') return;
      var clean = (a.textContent || '').replace(/[👉👈➡️➜➔→]/g, '').replace(/\s+/g, ' ').trim();
      // Normalise to "View bundle" — keep capitalisation lowercase brand-voice
      if (!clean || /view bundle/i.test(clean)) clean = 'View bundle';
      a.textContent = clean;
      a.dataset.svBundleDone = '1';
    });
  }

  // ---- M18 · Hide empty app sections -------------------------------------
  // The Selleasy PAL widget container sometimes reserves ~190px even when the
  // upsell isn't configured for this product. Also collapse empty legacy review badges.
  // Collapse anything that has no rendered text or media.
  function hideEmptyAppSections() {
    var candidates = document.querySelectorAll(
      '.shopify-section .lb-widget-pal, ' +
      '.shopify-section .shopify-app-block.lb-widget-pal, ' +
      '.spr-badge:empty, ' +
      '.spr-container:empty'
    );
    candidates.forEach(function (el) {
      var hasContent = el.innerText.trim().length > 2 ||
                       el.querySelector('img, svg, video, iframe, picture');
      if (hasContent) return;
      var section = el.closest('section.shopify-section') || el;
      section.style.display = 'none';
    });
    // Also: any .shopify-section whose ONLY descendant is an empty .lb-widget-pal
    document.querySelectorAll('section.shopify-section').forEach(function (s) {
      if (s.dataset.svEmptyChecked === '1') return;
      var pal = s.querySelector('.lb-widget-pal');
      if (pal && s.innerText.trim().length < 3 && !s.querySelector('img, svg, iframe')) {
        s.style.display = 'none';
      }
      s.dataset.svEmptyChecked = '1';
    });
  }

  /* =========================================================
     M19 · Replace BACK SOON image with text pill
     Wording (23 Sep 2026): sold-out cards say "Currently unavailable"
     (was "Restocking soon"). The badge text itself is now rendered by
     snippets/sv-product-badges.liquid; this is only a fallback.
     ========================================================= */
  function replaceBackSoonBadges() {
    var imgs = document.querySelectorAll(
      'img[src*="back_soon" i], img[src*="back-soon" i], img[src*="backsoon" i], ' +
      'img[alt*="back soon" i], img[alt*="BACK SOON" i]'
    );
    imgs.forEach(function (img) {
      if (img.dataset.svReplaced === '1') return;
      var card = img.closest('.product-card, .grid-product, .grid-item, .product-block, .product-single__photos, article, li, .featured-product');
      if (!card) card = img.parentElement;
      if (card && getComputedStyle(card).position === 'static') {
        card.style.position = 'relative';
      }
      if (card && card.querySelector('.sv-restocking-soon')) {
        img.style.display = 'none';
        img.dataset.svReplaced = '1';
        return;
      }
      var pill = document.createElement('span');
      pill.className = 'sv-restocking-soon';
      pill.textContent = 'Sold out';
      if (card) card.appendChild(pill);
      img.style.display = 'none';
      img.dataset.svReplaced = '1';
    });
    document.querySelectorAll('.product-card__badge, .grid-product__tag, [class*="badge"]').forEach(function (el) {
      if (el.dataset.svReplaced === '1') return;
      var txt = (el.textContent || '').trim().toUpperCase();
      if (txt === 'BACK SOON' || txt === 'SOLD OUT - BACK SOON') {
        el.textContent = 'Sold out';
        el.classList.add('sv-restocking-soon');
        el.dataset.svReplaced = '1';
      }
    });
  }

  /* M20d · RCL chip captions — reverted per user (2026-04-25). */
  function captionRclSwatches() { /* no-op */ }

  /* =========================================================
     M20c · Soften ALL-CAPS shipping copy (Wave 4b #17)
     'BULKY ITEMS (boards)' → 'Bulky items (boards)'.
     We can't edit Liquid, so rewrite at DOM level.
     ========================================================= */
  function softenBulkyItems() {
    document.querySelectorAll('strong, em, b').forEach(function (el) {
      if (el.dataset.svSoftened === '1') return;
      var t = (el.textContent || '').trim();
      // Match standalone all-caps shipping labels
      if (/^BULKY\s*ITEMS?\b/i.test(t) && t === t.toUpperCase()) {
        el.textContent = t.charAt(0).toUpperCase() + t.slice(1).toLowerCase();
        el.dataset.svSoftened = '1';
      }
    });
  }

  /* =========================================================
     M20 · Hide empty legacy review badges
     ========================================================= */
  function hideZeroReviewStars() {
    document.querySelectorAll('.spr-badge').forEach(function (el) {
      if (el.dataset.svZeroChecked === '1') return;
      var txt = (el.textContent || '').replace(/\s+/g, ' ').trim();
      var zero =
        /\b0\s*reviews?\b/i.test(txt) ||
        /\bno\s+reviews?\b/i.test(txt) ||
        /be\s+the\s+first\s+to\s+(write|review)/i.test(txt) ||
        (el.classList.contains('spr-badge') && (el.getAttribute('data-rating') === '0' || el.getAttribute('data-rating') === '0.0'));
      if (/\(0\)/.test(txt)) zero = true;
      if (zero) {
        el.setAttribute('data-sv-empty', '1');
        el.style.display = 'none';
      }
      el.dataset.svZeroChecked = '1';
    });
  }

  /* =========================================================
     M21 · Mobile sticky ATC bar (PDP)
     ========================================================= */
  function initMobileStickyAtc() {
    if (window.innerWidth > 749) return;
    if (document.body.classList.contains('template-product') === false) return;
    if (document.querySelector('.sv-setup, [data-sv-setup], #complete-your-setup')) {
      document.querySelectorAll('.sv-mobile-atc').forEach(function (bar) {
        bar.remove();
      });
      return;
    }
    if (document.querySelector('.sv-mobile-atc')) return;
    var inlineBtn = document.querySelector('.product-form__submit, button[name="add"], .add-to-cart, form[action*="/cart/add"] button[type="submit"]');
    if (!inlineBtn) return;
    var form = inlineBtn.closest('form');
    if (!form) return;
    var bar = document.createElement('div');
    bar.className = 'sv-mobile-atc';
    var thumb = document.createElement('div');
    thumb.className = 'sv-mobile-atc__thumb';
    var firstImg = document.querySelector('.product-single__photos img, .product__media img, .product-image img');
    if (firstImg && firstImg.src) {
      var i = document.createElement('img');
      i.src = firstImg.src;
      i.alt = '';
      thumb.appendChild(i);
    }
    var priceWrap = document.createElement('div');
    priceWrap.className = 'sv-mobile-atc__price';
    var priceEl = document.querySelector('.product-single__meta .price, .price__regular .price-item, .product__price');
    var priceText = priceEl ? priceEl.textContent.replace(/\s+/g,' ').trim().split(' ')[0] : '';
    var titleEl = document.querySelector('.product-single__title, h1.product__title');
    var titleText = titleEl ? titleEl.textContent.trim() : '';
    var titleShort = titleText.length > 32 ? titleText.slice(0,32).trim() + '…' : titleText;
    priceWrap.innerHTML = '<small>' + (titleShort || 'This item') + '</small>' + (priceText || '');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sv-mobile-atc__btn';
    btn.textContent = inlineBtn.disabled ? 'Sold out' : 'Add to cart';
    if (inlineBtn.disabled) btn.setAttribute('disabled', 'disabled');
    btn.addEventListener('click', function () {
      try {
        inlineBtn.scrollIntoView({ block: 'center', behavior: 'smooth' });
        setTimeout(function () { inlineBtn.click(); }, 300);
      } catch(_) { inlineBtn.click(); }
    });
    bar.appendChild(thumb);
    bar.appendChild(priceWrap);
    bar.appendChild(btn);
    document.body.appendChild(bar);
    function update() {
      var r = inlineBtn.getBoundingClientRect();
      var below = r.top > window.innerHeight - 40;
      var above = r.bottom < 80;
      if (below || above) bar.classList.add('is-visible');
      else bar.classList.remove('is-visible');
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    function syncBtn() {
      if (inlineBtn.disabled || /sold\s*out/i.test(inlineBtn.textContent || '')) {
        btn.setAttribute('disabled', 'disabled');
        btn.textContent = 'Sold out';
      } else {
        btn.removeAttribute('disabled');
        btn.textContent = 'Add to cart';
      }
      var p = document.querySelector('.product-single__meta .price, .price__regular .price-item, .product__price, .product-single__meta .product-price__price');
      if (p) {
        var t = p.textContent.replace(/\s+/g,' ').trim().split(' ')[0];
        priceWrap.innerHTML = '<small>' + (titleShort || 'This item') + '</small>' + (t || '');
      }
    }
    document.addEventListener('variant:change', syncBtn);
    document.addEventListener('product:variant-change', syncBtn);
    var mo = new MutationObserver(syncBtn);
    mo.observe(inlineBtn, { attributes: true, attributeFilter: ['disabled'] });
  }

  /* =========================================================
     M22 · Hero overlay injection (Wave 4a hero)
     ========================================================= */
  // Hero slide configs keyed by the original h2.hero__title text
  // (which Shopify renders authoritatively per slide).
  // Order matters — most specific match first.
  var SV_HERO_SLIDES = [
    {
      match: /\bkids?\s*zone\b|\bgroms?\b/i,
      kicker: 'For the Groms',
      title: 'KIDS ZONE',
      cta: { label: 'Shop Kids', href: '/collections/kids-zone' },
      chips: [
        { label: 'Softboards', href: '/collections/summervibes-kids-softboards' },
        { label: 'Bodyboards', href: '/collections/boogie-boards' },
        { label: 'Skimboards', href: '/collections/skimboards' }
      ]
    },
    {
      match: /\bbodyboard|boogie/i,
      kicker: 'Fun for Everyone',
      title: 'BODYBOARDS',
      cta: { label: 'Shop Bodyboards', href: '/collections/boogie-boards' },
      chips: [
        { label: 'Bodyboards', href: '/collections/boogie-boards' },
        { label: 'Bodyboard Bags', href: '/collections/bodyboardbags' },
        { label: 'Leashes', href: '/collections/bodyboard-leashes' }
      ]
    },
    {
      match: /\bsoftboard/i,
      kicker: 'Premium Quality, Unmatched Value',
      title: 'SOFTBOARDS',
      cta: { label: 'Shop Softboards', href: '/collections/softboards' },
      chips: [
        { label: 'Kids', href: '/collections/summervibes-kids-softboards' },
        { label: 'Shortboards', href: '/collections/softboard-shortboards' },
        { label: 'Mid & Longboards', href: '/collections/mini-mal-longboard-softboards' }
      ]
    },
    {
      match: /\bsurf\s*hardware|\bhardware\b|\bcovers?\b|\bleash|\btraction|\bfins?\b|\bboard.?bag/i,
      kicker: 'Covers · Traction · Leashes · Fins',
      title: 'SURF HARDWARE',
      cta: { label: 'Shop Hardware', href: '/collections/surf-hardware' },
      chips: [
        { label: 'Boardbags', href: '/collections/boardbags' },
        { label: 'Leashes', href: '/collections/leashes' },
        { label: 'Traction', href: '/collections/traction' },
        { label: 'Fins', href: '/collections/fins' }
      ]
    },
    {
      match: /\bsnorkel|\bmask|\bbeach\s*gear|\bdive\b/i,
      kicker: 'Beyond the Surf',
      title: 'BEACH GEAR',
      cta: { label: 'Shop Beach Gear', href: '/collections/snorkel-sets' },
      chips: [
        { label: 'Mask & Snorkel', href: '/collections/snorkel-sets' },
        { label: 'Skimboards', href: '/collections/skimboards' },
        { label: 'Surf Hire', href: '/collections/surf-hire-rentals-coolangatta' }
      ]
    },
    {
      match: /\bsurfboards?\b/i,
      kicker: 'Quality, User-Friendly',
      title: 'SURFBOARDS',
      cta: { label: 'Shop All Surfboards', href: '/collections/surfboards' },
      chips: [
        { label: 'Shortboards', href: '/collections/shortboard-surfboards' },
        { label: 'Mid-Lengths', href: '/collections/mid-length-surfboards' },
        { label: 'Longboards', href: '/collections/longboard-surfboards' }
      ]
    }
  ];
  // Generic fallback if h2 text doesn't match any pattern (rare)
  var SV_HERO_FALLBACK = SV_HERO_SLIDES[5]; // Surfboards is broadest fallback

  function pickHeroConfig(slideEl, idx) {
    // Primary signal: the slide's existing <h2.hero__title> text (set by merchant in Shopify admin)
    var h2 = slideEl.querySelector('h2.hero__title, .hero__title');
    var titleText = h2 ? (h2.textContent || '').trim() : '';
    // Secondary fallback: image filename or alt
    var img = slideEl.querySelector('img');
    var src = img ? (img.src || img.getAttribute('data-src') || '') : '';
    var hay = (titleText + ' ' + src).toLowerCase();
    for (var i = 0; i < SV_HERO_SLIDES.length; i++) {
      if (SV_HERO_SLIDES[i].match.test(hay)) return SV_HERO_SLIDES[i];
    }
    return SV_HERO_FALLBACK;
  }
  function injectHeroOverlay() {
    var slides = document.querySelectorAll('.slideshow__slide, .hero__slide');
    if (!slides.length) return;
    slides.forEach(function (slide, idx) {
      if (slide.dataset.svHeroDone === '1') return;
      var cfg = pickHeroConfig(slide, idx);
      if (getComputedStyle(slide).position === 'static') slide.style.position = 'relative';
      var overlay = document.createElement('div');
      overlay.className = 'sv-hero-overlay';
      overlay.innerHTML =
        '<p class="sv-hero-overlay__kicker">' + cfg.kicker + '</p>' +
        '<h2 class="sv-hero-overlay__title">' + cfg.title + '</h2>' +
        '<div class="sv-hero-overlay__row">' +
          '<a class="sv-hero-overlay__cta" href="' + cfg.cta.href + '">' + cfg.cta.label + '</a>' +
        '</div>' +
        (cfg.chips && cfg.chips.length ? (
          '<div class="sv-hero-overlay__chips">' +
            cfg.chips.map(function(c){
              return '<a class="sv-hero-overlay__chip" href="' + c.href + '">' + c.label + '</a>';
            }).join('') +
          '</div>'
        ) : '');
      slide.appendChild(overlay);
      slide.dataset.svHeroDone = '1';
    });
  }

  function bootExtras() {
    // injectFooterBrand removed entirely — was causing crashes
    syncCartCount();
    rewriteSalesPoint();
    rewriteSoldOutLabel();
    injectTrustStrip();
    accentValuePack();
    rewritePdpCopy();
    rewriteBundlyButton();
    hideEmptyAppSections();
    replaceBackSoonBadges();
    hideZeroReviewStars();
    softenBulkyItems();
    captionRclSwatches();
    injectHeroOverlay();
    initMobileStickyAtc();
    // Async-loaded apps (bundly, selleasy, rcl) settle later — re-run.
    setTimeout(function () {
      rewriteBundlyButton();
      hideEmptyAppSections();
      accentValuePack();
      replaceBackSoonBadges();
      hideZeroReviewStars();
      softenBulkyItems();
      captionRclSwatches();
      injectHeroOverlay();
      initMobileStickyAtc();
    }, 1500);
    setTimeout(function () {
      rewriteBundlyButton();
      hideEmptyAppSections();
      accentValuePack();
      replaceBackSoonBadges();
      hideZeroReviewStars();
      softenBulkyItems();
      captionRclSwatches();
      injectHeroOverlay();
    }, 4000);
    // RCL widget often hydrates very late — catch it again at 6s.
    setTimeout(captionRclSwatches, 6000);
    // Re-run accent after a short delay (bundly + collection cards inject async)
    setTimeout(accentValuePack, 800);
    setTimeout(accentValuePack, 2500);
    // Re-run on variant change (Impulse dispatches variant:change events; also catch DOM mutations).
    // The Add-to-cart button's disabled state may update slightly after the event,
    // so also run again on a short delay.
    function onVariantChange() {
      rewriteSalesPoint();
      setTimeout(rewriteSalesPoint, 120);
    }
    document.addEventListener('variant:change', onVariantChange);
    document.addEventListener('product:variant-change', onVariantChange);
    document.addEventListener('variant:change', rewriteSoldOutLabel);
    document.addEventListener('product:variant-change', rewriteSoldOutLabel);
    // Lightweight watch: only observe pickup + product form containers, debounced.
    // We avoid subtree+characterData on the whole PDP because it causes a feedback
    // loop when our rewriter itself mutates the DOM.
    var pickupContainer = document.querySelector('[data-store-availability-holder]');
    var formContainer   = document.querySelector('.product-single__form');
    if ('MutationObserver' in window && (pickupContainer || formContainer)) {
      var moDebounce = null;
      var mo = new MutationObserver(function () {
        if (svDomBusy) return;
        clearTimeout(moDebounce);
        moDebounce = setTimeout(function () {
          rewriteSalesPoint();
          rewriteSoldOutLabel();
        }, 150);
      });
      if (pickupContainer) mo.observe(pickupContainer, { childList: true });
      if (formContainer)   mo.observe(formContainer,   { childList: true, subtree: true });
      // Safety kill-switch: disconnect after 10s — by then the PDP is settled.
      setTimeout(function () { try { mo.disconnect(); } catch(e){} }, 10000);
    }
    // STOQ can update the button after a later size selection. Keep this
    // narrow observer alive; our availability card is outside the button.
    var availabilityButton = document.querySelector('button[data-add-to-cart]');
    if ('MutationObserver' in window && availabilityButton) {
      var availabilityDebounce = null;
      var availabilityObserver = new MutationObserver(function () {
        clearTimeout(availabilityDebounce);
        availabilityDebounce = setTimeout(rewriteSalesPoint, 150);
      });
      availabilityObserver.observe(availabilityButton, {
        childList: true, subtree: true, characterData: true,
        attributes: true, attributeFilter: ['disabled', 'class']
      });
    }
    // Re-sync when cart changes (Shopify dispatches a custom event in many themes)
    document.addEventListener('cart:updated', syncCartCount);
    document.addEventListener('cart:refresh', syncCartCount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); bootExtras(); });
  } else {
    init();
    bootExtras();
  }
  // ---- Recently Viewed: rebuild cards from localStorage --------
  // Impulse 9.0.0 mobile bug: theme JS fails to substitute {width} placeholders
  // and sometimes leaves the grid empty. We rebuild from localStorage as a fallback.
  function rebuildRecentlyViewed() {
    var section = document.querySelector('[data-section-type="recently-viewed"]');
    if (!section) return;
    var grid = section.querySelector('[id^="RecentlyViewed-"]');
    if (!grid) return;

    var recent = {};
    try { recent = JSON.parse(localStorage.getItem('theme-recent') || '{}'); } catch(e){ return; }
    var handles = Object.keys(recent);
    if (!handles.length) return;

    // Exclude the current product
    var currentHolder = section.querySelector('[data-product-handle]');
    var currentHandle = currentHolder ? currentHolder.getAttribute('data-product-handle') : '';
    handles = handles.filter(function (h) { return h !== currentHandle; });
    if (!handles.length) return;

    // Most recent 5 (localStorage stores in insertion order; reverse for newest first)
    handles = handles.slice(-5).reverse();

    // Skip if grid already has loaded images (don't double-render over a working theme)
    var existingImg = grid.querySelector('img');
    if (existingImg && existingImg.naturalWidth > 0 && existingImg.complete) return;

    var html = handles.map(function (handle) {
      var d = recent[handle];
      if (!d || !d.featuredImage) return '';
      var aspect = parseFloat(d.aspectRatio) || 100;

      // Substitute {width} placeholder — the bug we're working around
      var url360 = d.featuredImage.replace('{width}', '360');
      var url540 = d.featuredImage.replace('{width}', '540');
      var url720 = d.featuredImage.replace('{width}', '720');
      var url900 = d.featuredImage.replace('{width}', '900');

      // Build a readable title from the handle, then enforce the Summer vibes wordmark rule
      var title = handle.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
      title = title.replace(/Summer Vibes/g, 'Summer vibes');

      return '' +
        '<div class="grid__item grid-product small--one-half medium-up--one-fifth sv-rv-card">' +
          '<div class="grid-product__content">' +
            '<a href="' + d.url + '" class="grid-product__link">' +
              '<div class="grid-product__image-mask">' +
                '<div class="image-wrap sv-rv-wrap" style="padding-bottom:' + aspect + '%">' +
                  '<img class="grid-product__image sv-rv-img" ' +
                       'src="' + url540 + '" ' +
                       'srcset="' + url360 + ' 360w, ' + url540 + ' 540w, ' + url720 + ' 720w, ' + url900 + ' 900w" ' +
                       'sizes="(min-width: 769px) 20vw, 39vw" ' +
                       'alt="' + title + '">' +
                '</div>' +
              '</div>' +
              '<div class="grid-product__meta">' +
                '<div class="grid-product__title">' + title + '</div>' +
              '</div>' +
            '</a>' +
          '</div>' +
        '</div>';
    }).join('');

    if (html) {
      grid.innerHTML = html;
      grid.dataset.svRvRebuilt = '1';
    }
  }

  // Theme.js may try to populate first — we run a few times to override on failure.
  setTimeout(rebuildRecentlyViewed, 1200);
  setTimeout(rebuildRecentlyViewed, 3000);
  setTimeout(rebuildRecentlyViewed, 6000);

})();
